export enum FORM_KEYS {
	CREATE_CLIENT = 'create-client',
	UPDATE_CLIENT = 'update-client',
	UPDATE_USER = 'update-user',
	CREATE_USER = 'create-user',
	CREATE_CONTACT = 'create-contact',
	UPDATE_CONTACT = 'update-contact',
	CREATE_ASSIGNMENT = 'create-assignment',
	EDIT_ASSIGNMENT = 'edit-assignment',
	CREATE_DISABILITY_PROOF = 'create-disability-proof',
	UPDATE_DISABILITY_PROOF = 'update-disability-proof',
	CREATE_DISABILITY_TYPE = 'create-disability-type',
	UPDATE_DISABILITY_TYPE = 'update-disability-type',
	CREATE_INSTITUTION = 'create-institution',
	CREATE_INSTITUTION_PERSON = 'create-institution-person',
	UPDATE_INSTITUTION_PERSON = 'update-institution-person',
	CREATE_INSTITUTION_WORKPLACE = 'create-institution-workplace',
	UPDATE_INSTITUTION_WORKPLACE = 'update-institution-workplace',
	UPDATE_POSITION_SHARE = 'update-position-share',
	CREATE_CLIENT_RELATIVE = 'create-client-relative',
	CREATE_CAREER = 'create-career',
	CREATE_FDS = 'create-fds',
	EDIT_FDS = 'edit-fds',
	EDIT_CAREER = 'edit-career',
	CREATE_LEK = 'create-lek',
	CREATE_ADDITIONAL = 'create-additional',
	EDIT_ADDITIONAL = 'edit-additional',
	CREATE_NETWORK_CONTACT = 'create-network-contact',
	EDIT_NETWORK_CONTACT = 'edit-network-contact',
}
